import React, {SFC, useEffect, useRef, useState} from "react";
import {
    Box,
    Grid,
    Paper,
    Typography,
    makeStyles,
    useMediaQuery,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    Dialog
} from "@material-ui/core";
import {Theme, useTheme} from "@material-ui/core/styles";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { ReactComponent as DocSVG } from "../../../Images/vetDoctor.svg";
import {
    colorError,
    colorWhite
} from "../../../Constants/theme";
import * as objectorarray from "objectorarray";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {
    updatePickedDate,
    updatePickedTimeSlot,
    updateVetId,
    updateVetProfile,
    updateVetProfileId
} from "../../../redux/scheduleAppointment/scheduling.actions";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import VetProfile from "../../Modals/VetProfile";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import {specialities} from "../../../Constants/specialities";

interface Props {
	name: string,
	profileId: number,
	image: string,
	userId: number,
	workDays: objectorarray,
    redirect?: boolean,
    selectedWorkDay: number,
    timeZone: string,
    setSelectedWorkDay: (number: number) => void;
}

const useStyle = makeStyles((theme: Theme) => ({
    wrapper: {
        height: "100%",
        marginTop: 90,
        marginBottom: 50,
    },
    doctorList: {
        width: "100%",
        padding: 10,
        paddingBottom: 40,
        marginBottom: 10,
    },
    workDay: {
        marginTop: 10,
        marginRight: 10,
        width: 89,
        height: 26,
        fontSize: 13,
        fontWeight: 400,
        padding: 5,
        flexShrink: 0,
        textAlign: "center",
        borderRadius: "40px",
        color: colorWhite,
        [theme.breakpoints.down("xs")]: {
            width: 95,
        }
    },
    workDays: {
        marginTop: 15,
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap"
    },
    doctorListMobile: {
        padding: "20px 40px"
    },
    avatarPaper: {
        width: 105,
        height: 105,
    },
    availability: {
        marginTop: 10,
        width: "100%",
    }
}));

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & { children?: React.ReactElement<any, any> },
	ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const VetAvailabilityListItem: SFC<Props> = ({name, profileId, userId, image, workDays, redirect = false, selectedWorkDay, setSelectedWorkDay, timeZone}: Props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const classes = useStyle();
    const imageRef = useRef(null);
    const [linkToImage, setLinkToImage] = useState(image);
    const handleImageLoadError = () => {
        setLinkToImage("");
    };
    const handleWorkdaySelected = (e, newValue) => {
        setSelectedWorkDay(newValue);
        return
    };

    return (
        <Grid className={`${classes.doctorList} ${isMobile? classes.doctorListMobile : ""}`}>
            <Grid container justify="space-around" alignItems="flex-start">
                <Grid item justify="center">
                    <Box marginBottom={"25px"}>
                        <Paper elevation={3} className={classes.avatarPaper} square>
                            {
                                linkToImage ?
                                    <img
                                        alt="vet image"
                                        ref={imageRef}
                                        src={linkToImage}
                                        style={{objectFit: "cover"}}
                                        onError={handleImageLoadError}
                                        width="100%"
                                        height="100%"
                                    />
                                    :
                                    <DocSVG className={classes.avatarPaper}/>
                            }
                        </Paper>
                    </Box>
                </Grid>
                <Grid item sm={9} container>
                    <Grid item xs={12} alignItems="center" direction="column">
                        <Box>
                            <a style={{textDecoration: "none"}}><Typography variant="h3">{name}</Typography></a>
                        </Box>
                        <Grid>
                            <RadioGroup name="workday" value={Number(selectedWorkDay)} row onChange={(e, val) => handleWorkdaySelected(e, val)}>
                                {workDays.map((workday) => (
                                    <FormControlLabel value={workday.id} control={<Radio/>}
                                        label={moment(workday.workdayBegins).tz(timeZone).format("LLL")+"-"+moment(workday.workdayEnds).tz(timeZone).format("LLL")}/>
                                ))}
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default VetAvailabilityListItem;
